<template>

    <div class="main-bd mg20">

        <el-row>
            <el-col :span="10">
                <div class="clue-wrapper">
                    <div class="clue-view-border">
                        <h5>线索详情</h5>

                        <div class="userInfo-group" v-if="clueInfo.is_deleted == 0">
                            <el-row>
                                <el-button v-if="clueInfo.customer_id == 0" type="success" size="medium"
                                           @click="handleContact()">关联客户
                                </el-button>
                                <el-button type="primary" size="medium" @click="handleUpdate()">编辑线索</el-button>
                                <el-button v-if="Acs('/sales-leads/delete')" type="danger" size="medium"
                                           @click="handleDelete()">删除线索
                                </el-button>
                                <el-button v-if="Acs('/sales-leads/user-change')" type="primary" size="small"
                                    @click="handleBatchSalers()"> 转交线索
                                </el-button>
                            </el-row>
                        </div>

                        <div class="userInfo-group">
                            <span>申请人信息</span>
                            <el-row :gutter="20">
                                <el-col :span="12" class="order-item">
                                    <label>申请人：</label>
                                    <span>{{clueInfo.contact_name}}</span>
                                </el-col>
                                <el-col :span="12" class="order-item">
                                    <label>申请产品：</label>
                                    <span v-for="product in clueInfo.products" :key="product.product_id">{{product.product_name}}<span
                                            v-if="clueInfo.products.length != 1">，</span></span>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12" class="order-item">
                                    <label>申请时间：</label>
                                    <span>{{clueInfo.created_at | date }}</span>
                                </el-col>
                                <el-col :span="12" class="order-item">
                                    <label>手机：</label>
                                    <span>{{clueInfo.mobile}}/{{clueInfo.banding_mobile}} <el-button v-if="clueInfo.mobile != ''" type="text" size="mini" icon="el-icon-unlock" @click="unlockMobile(clueInfo)">解密</el-button></span>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12" class="order-item">
                                    <label>申请人职务：</label>
                                   <span>{{clueInfo.applicat_job == 1 ? '校长' : clueInfo.applicat_job == 2 ? '主任' : clueInfo.applicat_job == 3 ? '教师' : clueInfo.applicat_job == 4 ? '其他' : '暂无'}}</span>
                                </el-col>
                                <el-col :span="12" class="order-item">
                                    <label>绑定时间：</label>
                                    <span>{{clueInfo.bind_at ? clueInfo.bind_at : '暂无'}}</span>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="userInfo-group">
                            <span>客户信息</span>
                            <el-row>
                                <el-col :span="12" class="order-item">
                                    <label>客户名称：</label>
                                    <span>
                                        {{clueInfo.customer_name}}
                                        <i v-if="clueInfo.customer_id > 0" style="color: #67C23A;"
                                           class="el-icon-circle-check">已关联</i>
                                        <i v-else style="color: #F56C6C;" class="el-icon-circle-close">未关联</i>
                                    </span>
                                </el-col>
                                <el-col :span="12" class="order-item">
                                    <label>所在地：</label>
                                    <span>{{clueInfo.district_names}}</span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" class="order-item">
                                    <label>学校班级数：</label>
                                    <span>{{clueInfo.class_num ? clueInfo.class_num : '暂无相关信息'}}</span>
                                </el-col>
                                <el-col :span="12" class="order-item">
                                    <label>学校老师数：</label>
                                    <span>{{clueInfo.teacher_num ? clueInfo.teacher_num : '暂无相关信息'}}</span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" class="order-item">
                                    <label>负责人姓名：</label>
                                    <span>{{clueInfo.leader_name ? clueInfo.leader_name : '暂无'}}</span>
                                </el-col>
                                <el-col :span="12" class="order-item">
                                    <label>负责人电话：</label>
                                    <span>{{clueInfo.leader_mobile ? clueInfo.leader_mobile : '暂无'}} <el-button v-if="clueInfo.leader_mobile != ''" type="text" size="mini" icon="el-icon-unlock" @click="unlockMobile(clueInfo)">解密</el-button></span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" class="order-item" v-if="clueInfo.leader_job != 0">
                                    <label>负责人职位：</label>
                                    <span>{{clueInfo.leader_job == 1 ? '校长' : '主任'}}</span>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="userInfo-group">
                            <span>业务员信息</span>
                            <el-row>
                                <el-col :span="8" class="order-item">
                                    <label>业务员：</label>
                                    <span>{{clueInfo.username}}</span>
                                </el-col>
                                <el-col :span="8" class="order-item">
                                    <label>所属部门：</label>
                                    <span>{{clueInfo.branch_name}}</span>
                                </el-col>
                                <el-col :span="8" class="order-item">
                                    <label>线索来源：</label>
                                    <span>{{clueInfo.source_name}}</span>
                                </el-col>
                            </el-row>
                        </div>

                        <div class="userInfo-group">
                            <span>备注信息</span>
                            <span>温馨提示: 学校及教育局线索，如信息属实需要新建为客户，培训机构不做特殊要求</span>
                            <el-row>
                                <el-col class="order-item">
                                    <label>备注内容：</label>
                                    <span>{{clueInfo.memo}}</span>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <!-- 关联客户 -->
                    <contact-customer-dialog v-if="clueInfo"
                                             :showDialog="showContact"
                                             :clue="clueInfo"
                                             @checkStatus="checkStatus"
                                             @changeShow="changeShow2"
                                             @saveCallback="saveCallback"
                                             :key="contact_customer_dialog_key">
                    </contact-customer-dialog>
                </div>

                <div class="clue-wrapper">
                    <div class="clue-view-border">
                        <h5>操作日志</h5>
                        <div class="userInfo-group">
                            <el-table :data="logs" style="width: 100%">
                                <el-table-column prop="modify_username" label="操作人"></el-table-column>
                                <el-table-column prop="modify_time" label="操作时间"></el-table-column>
                                <el-table-column prop="flag_name" label="操作内容"></el-table-column>
                                <el-table-column prop="username" label="绑定人"></el-table-column>
                            </el-table>
                            <el-row>
                            </el-row>
                        </div>
                        <div class="userInfo-group" v-if="linkPage">
                            <pagination :linkPage="linkPage" :enableEvent="true"
                                        @change="watchLogsPageChange"></pagination>
                        </div>
                    </div>
                </div>

            </el-col>

            <el-col :span="14">
                <div class="clue-wrapper">
                    <div class="clue-view-border">
                        <h5>跟进线索</h5>
                        <div class="userInfo-group" v-if="clueInfo.is_deleted == 0">
                            <el-form ref="form" :model="traceModel" :rules="rules" label-width="120px" size="small">
                                <el-form-item label="联系人" prop="contact_name">
                                    <el-select v-model="traceModel.contact_name" style="width:100%"
                                               placeholder="请选择联系人">
                                        <el-option
                                                v-for="(contact, key) in contacts"
                                                :label="contact.name"
                                                :value="contact.name"
                                                :key="key"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="跟进内容" prop="content">
                                    <el-input type="textarea" v-model="traceModel.content"></el-input>
                                    温馨提示: 线索关联客户后，跟进记录将会与客户跟进合并
                                </el-form-item>
                                <el-form-item label="申请人真实性" prop="sales_status" style="display: inline-block;">
                                    <el-radio-group v-model="traceModel.sales_status" >
                                        <el-radio label="3">未核实</el-radio>
                                        <el-radio label="4">正式合作客户</el-radio>
                                        <el-radio label="1">信息属实</el-radio>
                                        <el-radio label="2">信息不属实</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="traceModel.sales_status == '2'" label-width="5px" prop="sales_status_child" style="display: inline-block;">
                                    <el-select v-model="traceModel.sales_status_child" placeholder="请选择">
                                        <el-option
                                            v-for="item in invalid_types"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <br>
                                <el-form-item label="负责人真实性" prop="leader_status" style="display: inline-block;">
                                    <el-radio-group v-model="traceModel.leader_status">
                                        <el-radio label="3">未核实</el-radio>
                                        <el-radio label="4">正式合作客户</el-radio>
                                        <el-radio label="1">信息属实</el-radio>
                                        <el-radio label="2">信息不属实</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="traceModel.leader_status == '2'" label-width="5px" prop="leader_status_child" style="display: inline-block;">
                                    <el-select v-model="traceModel.leader_status_child" placeholder="请选择">
                                        <el-option
                                            v-for="item in invalid_types"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    属于当前单位的用户申请的信息则为信息属实，否则信息不属实
                                </el-form-item>
                                <el-form-item>
                                    <el-button :loading="submiting" type="success" @click="submitTrace()">保存跟进</el-button>
                                    <el-button @click="resetForm()">重置</el-button>
                                </el-form-item>
                            </el-form>

                        </div>

                        <div class="userInfo-group">
                            <el-row :gutter="40">
                                <el-col :span="8">跟进记录</el-col>
                                <el-col :span="8">申请人真实性：{{clueInfo.status_str}}</el-col>
                                <el-col :span="8">负责人真实性：{{clueInfo.leader_status_str}}</el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-timeline v-if="traces.length > 0">
                                    <el-timeline-item v-for="(trace, key) in traces" :timestamp="trace.created_at"
                                                      placement="top" :key="key">
                                        <el-card>
                                            <h4>{{trace.content}}</h4>
                                            <p>联系人: {{trace.contact_name}}</p>
                                            <p>{{trace.username}} 提交于 {{trace.created_at}}</p>
                                        </el-card>
                                    </el-timeline-item>
                                </el-timeline>
                            </el-row>
                        </div>


                    </div>

                </div>
            </el-col>

        </el-row>

        <assign-clue-dialog
                v-if="showAssign"
                text="转交业务员"
                :actionYes="action_callback"
                @changeShow="changeShow1">
        </assign-clue-dialog>
    </div>


</template>
<script>
    import ClueService from "~/services/SaleClues"
    import ContactCustomerDialog from "~/views/clue/dialog/contactCustomerDialog.vue";
    import Pagination from "~/widgets/Pagination.vue";
    import MessageService from "~/services/Message";
    import CommonService from "~/services/common";
    import AssignClueDialog from "~/views/clue/dialog/assignClueDialog.vue";
    import Config from "~/config/params";
    import ContactService from "~/services/contact";
    import moment from 'moment'
    import 'moment/locale/zh-cn'

    moment.locale('zh-cn')

    export default {
        data() {
            let clueId = this.$route.query['id'].toString();
            return {
                clueId: clueId,
                clueInfo: {},
                showContact: false,
                // 销售跟进模型
                traceModel: {},
                contacts: [], // 联系人列表
                traces: [], // 销售线索跟进记录列表
                logs: [],
                linkPage: null,
                rules: {
                    content: [
                        {
                            required: true,
                            message: "请输入跟进内容",
                            trigger: "blur"
                        },
                    ],
                    contact_name: [
                        {
                            required: true,
                            message: "联系人不能为空",
                            trigger: "blur"
                        },
                    ],
                    sales_status: [
                        {
                            required: true,
                            message: "请选择申请人真实性",
                            trigger: "blur"
                        },
                    ]
                    ,
                    leader_status: [
                        {
                            required: true,
                            message: "请选择负责人真实性",
                            trigger: "blur"
                        },
                    ]
                    ,
                    sales_status_child: [
                        {
                            required: true,
                            message: "请选择申请人真实性原因",
                            trigger: "blur"
                        },
                    ]
                    ,
                    leader_status_child: [
                        {
                            required: true,
                            message: "请选择负责人真实性原因",
                            trigger: "blur"
                        },
                    ]
                },
                submiting: false,
                showAssign: false,
                invalid_types: [],
                valid_types: [],
                contact_customer_dialog_key: 0
            }
        },
        components: {
            ContactCustomerDialog,
            Pagination,
            AssignClueDialog
        },
        created() {
            // 查找label为'信息不属实'的元素
            const invalid_info = Config.leadStatuses().find(item => item.label === '信息不属实');
            // 获取其children数组
            this.invalid_types = invalid_info  ? invalid_info.children : [];

            MessageService.readClueMessage(this);

            this.getCurrentInfo(this.clueId);
            this.getTraces(this.clueId);
            this.getLogs({clue_id: this.clueId});

            this.traceModel = this.getTraceModel();

        },
        filters: {
            date(val) {
                return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
            }
        },
        mounted() {
            if(this.$route.query.hasOwnProperty('check_status') && this.$route.query['check_status']){
                this.checkStatus();
            }
        },
        methods: {
            // 获取当前要查看的线索相关信息
            getCurrentInfo(id) {
                ClueService.getInfo(id).then(res => {
                    if (res.code == 0) {
                        this.clueInfo = Object.assign({}, res.data);
                        // 对于还没有绑定客户的线索来说，联系人只能从线索上提取
                        if (this.clueInfo.customer_id == 0) {

                            if (this.clueInfo.contact_name != '') {
                                this.contacts.push({
                                    mobile: this.clueInfo.mobile,
                                    name: this.clueInfo.contact_name
                                });
                            }

                            if (this.clueInfo.leader_name != '') {
                                this.contacts.push({
                                    mobile: this.clueInfo.leader_mobile,
                                    name: this.clueInfo.leader_name
                                });
                            }
                        }

                    }
                })
            },
            handleContact() {
                this.contact_customer_dialog_key ++;
                this.showContact = true;
            },

            changeShow2(isShow) {
                this.showContact = isShow;
            },

            saveCallback() {
                this.$router.push({
                    path: this.$route.query['referer']
                });
            },

            getTraceModel() {
                return {
                    customer_id: this.clueInfo.customer_id,
                    sale_clue_id: this.clueId,
                    product_id: '',
                    contact_id: 0,
                    contact_name: '',
                    content: '',
                    sales_status: '',
                    sales_status_child: '',
                    leader_status: '',
                    leader_status_child: ''
                }
            },

            submitTrace() {

                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.submiting = true;
                        ClueService.trace(this.traceModel).then(res => {
                            this.submiting = false;
                            if (res.code == 0) {
                                this.clueInfo.status = this.traceModel.sales_status;
                                this.clueInfo.status_child = this.traceModel.sales_status_child;
                                this.clueInfo.leader_status = this.traceModel.leader_status;
                                this.clueInfo.leader_status_child = this.traceModel.leader_status_child;
                                this.$message({type: "success", message: "保存成功!"});
                                this.getTraces(this.clueId);
                                this.resetForm();
                                this.getCurrentInfo(this.clueId);
                            } else {
                                this.$message({type: "error", message: res.msg});
                            }
                        }).catch(err => {
                            this.submiting = false;
                            console.error(err);
                        })
                    }
                    return;
                })
            },

            getTraces(clueId) {
                ClueService.getTraces(clueId).then(res => {
                    if (res.code == 0) {
                        this.traces = res.data;
                    }
                })
            },

            resetForm() {
                this.traceModel = {};
                this.traceModel = this.getTraceModel();
            },

            handleUpdate() {
                this.$router.push({
                    path: "/sales-leads/update",
                    query: {
                        id: this.clueId,
                        referer: this.$route.query['referer']
                    }
                })
            },

            handleDelete() {

                let leads_ids = [];

                leads_ids.push(this.clueId);

                this.$confirm("确定要删除该条线索吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {
                    ClueService.deleteClues(leads_ids).then(res => {
                        if (res.code == 0) {
                            this.$message({message: '删除成功', type: 'success'});
                            this.$router.push({path: "/sales-leads/my-index"})
                        }
                    });

                }).catch(() => {
                });
            },

            getLogs(params) {
                CommonService.getSalesLogs(params).then(res => {
                    if (res.code == 0 && res.data) {
                        this.logs = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                    }
                })
            },


            watchLogsPageChange(pageParams) {
                this.getLogs({
                    clue_id: this.clueId,
                    page: pageParams["page"],
                    perPage: pageParams["perPage"]
                });
            },

            unlockMobile(row) {
                ContactService.decodeMobile({id: row.id, type: 3}).then(res => {
                    if (res.code == 0 && res.data) {
                        this.$message.success("解密成功！");
                        row.mobile = res.data.mobile;
                        row.banding_mobile = res.data.banding_mobile;
                        row.leader_mobile = res.data.phone_number;
                    }
                })
            },

            // 批量操作或者转交业务员
            handleBatchSalers() {
                this.showAssign = true;
                var _this = this;
                this.action_callback = function (uid) {
                    let params = {
                        leads_ids: [_this.clueId],
                        user_id: uid
                    }
                    ClueService.transferSalers(params).then(res => {
                        if (res.code == 0) {
                            _this.$message({
                                message: "批量转交成功",
                                type: "success"
                            });
                            _this.showAssign = false;
                            _this.getCurrentInfo(_this.clueId);
                        }
                    })
                }
            },

            changeShow1(isShow) {
                this.showAssign = isShow;
            },

            action_callback() {
            },

            checkStatus(){
                this.$refs["form"].validate();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/clue/view.vue